import { IDialogStyles, ITheme } from '@fluentui/react';
import { Theme } from '../../Models/Constants/Enums';

export const getDialogStyles = (
    _themeSetting: Theme,
    _theme: ITheme
): Partial<IDialogStyles> => {
    return {
        main: { minWidth: '480px !important' }
    };
};
